import { WholeNumber_Schema } from "@/utilities";
import { z } from "zod";
import { ParameterSlug_MarketplacePrice } from "./filterHelpers";

export const FilterOptionId_Schema = z.number().int();

// Fielter field option schema
export const FilterOption_Schema = z.object({
  id: FilterOptionId_Schema,
  value: z.string(),
  slug: z.string(),
  active: z.boolean(),
  ifSelectedCount: WholeNumber_Schema,
});

export enum FilterType {
  Text = "text",
  SingleSelect = "single-select",
  MultiSelect = "multi-select",
  Range = "range",
}

/** Received from API, we don't work with it, we transform it into FilterType. */
enum Response_FieldType {
  ChooseOne = "choose_one",
  ChooseMultiple = "choose_multiple",
  Range = "range",
}

/** Received from API, we don't work with it, we transform it into FilterType. */
enum Response_FieldViewType {
  Dropdown = "dropdown",
  Slider = "slider",
  Checkboxes = "checkboxes",
}

export const FilterDefinition_Schema = z
  .object({
    id: z.number(), // Can be negative!
    slug: z.string(),
    name: z.string(),
    type: z.enum(Response_FieldType),
    viewType: z.enum(Response_FieldViewType),
    values: z.array(FilterOption_Schema),
    intMin: z.number(), // in cents
    intMax: z.number(), // in cents
    //unit: z.string().nullable(), // eg. Kč @todo
  })
  .transform(({ viewType, type, intMin, intMax, ...rest }) => ({
    ...rest,
    intMin: rest.slug === ParameterSlug_MarketplacePrice ? Math.floor(intMin / 100) : intMin,
    intMax: rest.slug === ParameterSlug_MarketplacePrice ? Math.ceil(intMax / 100) : intMax,
    unit: "Kč", // @todo not used now, hardcoded in filter component
    type: mapFieldDefinitionToFilterType(viewType, type),
  }));

// Sort option schema (no count)
export const SortOption_Schema = z.object({
  value: z.string(),
  label: z.string(),
});

// Sort definition schema
export const SortDefinition_Schema = z.object({
  field: z.string(),
  label: z.string(),
  options: z.array(SortOption_Schema),
  default: z.string(),
});

// Helpers:

/** Slug for the identification/fulltext filter field. */
export const IDENTIFICATION_FILTER_SLUG = "identification";

export function mapFieldDefinitionToFilterType(viewType: Response_FieldViewType, type: Response_FieldType): FilterType {
  const error = new Error(`Unknown combination of viewType: ${viewType} and type: ${type}`);

  if (viewType === Response_FieldViewType.Dropdown) {
    if (type === Response_FieldType.ChooseOne) {
      return FilterType.SingleSelect;
    } else if (type === Response_FieldType.ChooseMultiple) {
      return FilterType.MultiSelect;
    } else {
      throw error;
    }
  } else if (viewType === Response_FieldViewType.Slider) {
    if (type === Response_FieldType.Range) {
      return FilterType.Range;
    } else {
      throw error;
    }
  } else if (viewType === Response_FieldViewType.Checkboxes) {
    if (type === Response_FieldType.ChooseMultiple) {
      return FilterType.MultiSelect;
    } else if (type === Response_FieldType.ChooseOne) {
      // @todo this is invalid combination, though we will accepts it for now because it's not possible to fix it in API now
      return FilterType.MultiSelect;
    } else {
      throw error;
    }
  } else {
    throw error;
  }
}
